const rawApiBaseUrl =
  import.meta.env.VITE_API_URL ||
  import.meta.env.VITE_API_BASE_URL ||
  'http://localhost:5002'

function normalizeApiBaseUrl(value) {
  const trimmed = String(value || '').trim().replace(/\/+$/, '')
  if (!trimmed) return 'http://localhost:5002/api'
  return trimmed.endsWith('/api') ? trimmed : `${trimmed}/api`
}

export const API_BASE_URL = normalizeApiBaseUrl(rawApiBaseUrl)
export const SOCKET_URL =
  import.meta.env.VITE_SOCKET_URL ||
  API_BASE_URL.replace(/\/api$/, '')

export function apiUrl(path, params = {}) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  const base = API_BASE_URL.startsWith('http')
    ? API_BASE_URL
    : window.location.origin + API_BASE_URL
  const url = new URL(`${base}${normalizedPath}`)

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      url.searchParams.set(key, String(value).trim())
    }
  })

  return API_BASE_URL.startsWith('http')
    ? url.toString()
    : `${url.pathname}${url.search}`
}

export async function parseJsonResponse(response, fallbackMessage = 'Request failed') {
  const data = await response.json().catch(() => null)
  if (!response.ok) {
    const message = data?.message || data?.error || fallbackMessage
    const error = new Error(message)
    error.status = response.status
    error.data = data
    throw error
  }
  return data
}
